export enum BusinessRegionPath {
  AUS = `/au`,
  SGP = '/sg',
  Other = '/*',
  // For Myinfo's non-sandbox env, the callback url has been configured as [domainName (non-localhost)]/sg/callback where it will match /sg business region
  // However,for Myinfo's sandbox env, it requires the callback url mus be [localhost:3001/callback] and it did not support business region in the MyInfo sandbox env.
  // To avoid being navigate to /au region (default region if not specify business region in the path), We have to handle this special path specifically to make it redirect to /sg business region
  MyInfoCallbackForLocalOnly = '/callback'
}
